import { Button as PrButton, type ButtonProps } from 'primereact/button'

export interface AppButtonProps extends ButtonProps {
  /**
   * Buton tarzı (varsayılan `primary`):
   *  - `primary`   → dolu marka kırmızısı (ör. "Talebi Gönder").
   *  - `secondary` → kenarlıklı nötr, gri metin (ör. "İptal") = `outlined severity="secondary"`.
   * Diğer PrimeReact prop'ları (severity/text/loading/icon…) aynen geçer ve varyantı geçersiz kılabilir.
   */
  variant?: 'primary' | 'secondary'
}

/**
 * Paylaşılan Button (PrimeReact Button sarmalayıcı — Reuse Mandate). Uygulama genelinde tek tip
 * birincil/ikincil aksiyon görünümü; görünüm marka token'larından (primereact-overrides.css) gelir.
 */
export default function Button({ variant = 'primary', ...props }: Readonly<AppButtonProps>) {
  if (variant === 'secondary') {
    return <PrButton outlined severity="secondary" {...props} />
  }
  return <PrButton {...props} />
}
